// extracted by mini-css-extract-plugin
export var divider = "_qm-0";
export var systemMessage = "_qm-1";
export var systemMessageWrapper = "_qm-2";